<template>
  <div>
    <div class="vx-row">



      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <div class="vx-row">
            <div class="vx-col sm:w-1/4 w-full mb-1"><v-select :value="program" v-model="program"
                :options="formatOptions"></v-select></div>
            <div class="vx-col sm:w-1/4 w-full mb-1"><vs-button color="success" @click="satisListesi()"
                type="filled">Listele</vs-button></div>
          </div>





        </vx-card>

        <vs-table :data="data">
          <template slot="thead">

            <vs-th>Sipariş No</vs-th>
            <vs-th>Müşteri</vs-th>
            <vs-th>Detay</vs-th>


          </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                {{ data[indextr].orderNumber }}
              </vs-td>

              <vs-td>
                {{ data[indextr].musteri }}
              </vs-td>
              <vs-td>
                <vs-button color="success" @click="detay(indextr)" type="filled">Detay</vs-button>
              </vs-td>

            </vs-tr>
            <vs-tr>
              <vs-td></vs-td>
              <vs-td>Toplam {{ data.length }} Sipariş</vs-td>
              <vs-td></vs-td>
            </vs-tr>
          </template>

        </vs-table>

      </div>


    </div>


    <vs-popup fullscreen class="holamundo" title="Sipariş İçeriği" :active.sync="popupDetay">

      <vs-table :data="siparisIcerik">

        <template slot="thead">
          <vs-th style="border:1px solid #000000; padding:12px" sort-key="stokkodu">Stok Kodu</vs-th>
          <vs-th style="border:1px solid #000000; padding:12px" sort-key="stokkodu">Stok Adı</vs-th>
          <vs-th style="border:1px solid #000000; padding:12px" sort-key="stokkodu">Adet</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" style="border:1px solid #000000">


            <vs-td :data="data[indextr].urunKodu" style="border:1px solid #000000">
              {{ data[indextr].merchantSku }}
            </vs-td>
            <vs-td :data="data[indextr].stokAdi" style="border:1px solid #000000">
              {{ data[indextr].productName }}
            </vs-td>
            <vs-td :data="data[indextr].stokAdi" style="border:1px solid #000000">
              {{ data[indextr].quantity }}
            </vs-td>

          </vs-tr>

        </template>

      </vs-table>

    </vs-popup>


  </div>
</template>



<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import state from '../../store/state'
import Store from '../../store/store'
export default {
  data() {
    return {
      format: "yyyy-MM-dd",
      data: [],
      siparisIcerik: [],
      popupDetay: false,
      baslangic: '',
      formattedDate: '',
      formattedDate1: '',
      bitis: '',
      program: { id: 0, label: 'Pazaryeri' },
      check3: '',
      formatOptions: [],
    }
  },
  created() {
    this.tabList = Store.state.uzum.menuListForTabs;
    this.tabList.forEach((val, index) => {
      this.formatOptions.push({ label: val.name, id: val.name })
    });
  }, methods: {
    detay(id) {
      this.popupDetay = true
      //console.log(this.data[id].urunler)
      this.siparisIcerik = JSON.parse(this.data[id].urunler)
    },
    toplama() {
      var vm = this
      var sayi = 0
      this.data.forEach(element => {
        sayi = sayi + parseInt(element.satisAdet)
      });
      return sayi
      // this.toplam=parseInt(this.toplam)+parseInt(d)
      // return this.toplam
      //console.log(this.toplam)
    },
    satisListesi() {
      var vm = this

      const soap = require('soap')
      const url = state.sistemAddress

      // console.log(vm.formattedDate)
      const args = { program: this.program.label, baslik: 'siparisRaporu', tarih1: vm.formattedDate, tarih2: vm.formattedDate1, token: Store.state.tokenId, kullaniciId: '', siparisNo: '' }
      // console.log(args)
      soap.createClient(url, function (err, client) {
        client.standartSorguRapor(args, function (err, result) {
          if (result.standartSorguRaporResult == '-1') {
            Store.dispatch('logout')
          }
          vm.veriler = JSON.parse(result.standartSorguRaporResult)
          // console.log(vm.veriler)
          vm.data = vm.veriler
          // vm.eslesenStokListesi=vm.veriler





        })
      })
    },
  },
  components: {
    'v-select': vSelect,
    Datepicker
  }
}
</script>
